/**
 * GraphQL HTTP uses **only** the Core endpoint (`getCoreGraphqlEndpoint` → `/api/core/graphql/`);
 * live updates use the Core subscriptions client (`/ws/core/graphql/`).
 */
import {
    coreGraphql,
    coreGraphqlMultipartPostCreate,
    coreGraphqlMultipartRequest,
    coreGraphqlUpload,
    getCoreAuthToken,
    getCoreGraphqlEndpoint,
} from "../api/coreClient";

/** @deprecated use `coreGraphql` from `api/coreClient.js` */
export const websiteGraphqlRequest = coreGraphql;

/** @deprecated use `coreGraphqlMultipartRequest` */
export const websiteGraphqlMultipartRequest = coreGraphqlMultipartRequest;

/** @deprecated use `coreGraphqlMultipartPostCreate` */
export const websiteGraphqlMultipartPostCreate = coreGraphqlMultipartPostCreate;

/** Multipart GraphQL with ``File`` variables (e.g. ``sendDirectMessage``). */
export const websiteGraphqlUpload = coreGraphqlUpload;

/** Same token source as REST (`localStorage` key `token`). */
export const getWebsiteAuthToken = getCoreAuthToken;

/** Core GraphQL HTTP URL (not used for subscriptions). */
export const getWebsiteGraphqlEndpoint = getCoreGraphqlEndpoint;

